// ESM-Huelle um lib/scripts/pos/CLS_CDisplay.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.
 "use strict";

//var displayqueue = new Queue();
var execto=null;
//const adv_link="//wsl.localhost/Ubuntu-22.04/home/pos/etc/scripts/html/"
const adv_link="/home/pos/etc/scripts/html/"
//var sec_monitor;

function CDisplay() {

		var me = this;
		me.filearray = [];
		this.advertnr = 0;
		console.log('In Display');
		this.lines = new Array();
		this.lineCount = 0;
		if (POS.EnvProperties.CUSTOMERDISPLAY == "NO") {
			return;
		}

		if (me.filearray.length==0){
			me.loadAdvFiles(me);
		}
}



CDisplay.prototype.sendToDisplay = function(output,me) {
	 fs.writeFile('/home/pos/etc/scripts/html/display.html',output);
	 return;
}


CDisplay.prototype.loadAdvFiles = function(me) {


	fs.readdir('/home/pos/etc/scripts/html/',function (err,files) { 
					me.filearray=[];
					if (!err){
						if (files.length && files.length>0){
							for (var i=0;i<files.length;i++){
								if (files[i].startsWith('werbung') && files[i].endsWith('jpg')){
									me.filearray.push(files[i]);
								}
							}
						}
					}
	});
}


CDisplay.prototype.reset = function() {
    this.lines = new Array();
    this.lineCount = 0;
}

CDisplay.prototype.addLine = function() {
    this.lines[this.lineCount] = new CDisplayLine();
    this.lineCount++;
}


CDisplay.prototype.show33win = function(me) {
             var output = fs.readFileSync('/home/pos/etc/scripts/html/33Gewinn.html');
             if (output==""){
                } else {
                 clearTimeout(POS.displayAdvertTo);
                 me.sendToDisplay(output,me);
                 this.show33now=true;
                }
                setTimeout(function(){
                                me.show33now=false;
                                me.showAdvertising(me);
                                }, 15000);
}



CDisplay.prototype.showAdvertising = function(me) {
				if (me.belegQRAktiv) return; // e-Beleg-QR steht - zeigeBelegQR startet die Werbung danach selbst
				me.advertnr=me.advertnr+1;
		if (me.filearray && me.filearray.length){
         			if (me.advertnr>=me.filearray.length) me.advertnr=0;
					if (!(POS.isDisplayActive===1)){

var output =`<html>
<head><meta charset="utf-8"><title>Display</title>
<style type="text/css"> 
body {overflow-y: hidden;overflow-x: hidden; width:1024px; height: 768px; margin: 0; padding: 0; } 
img { padding: 0; display: block; margin: 0 auto; width:1024px; height: 768px; }</style>
</head>
<body><img src=`
+adv_link+me.filearray[me.advertnr]+'></body></html>';
					me.sendToDisplay(output,me);
					}
				} else {
					me.advertnr=-1;
					me.loadAdvFiles(me);
				}
		clearTimeout(POS.displayAdvertTo);
		POS.displayAdvertTo = null;
		POS.displayAdvertTo = setTimeout(function(){me.showAdvertising(me)}, 15000);
}




CDisplay.prototype.out = function() {

    var me = this;
	console.log('Display out');
    if (POS.EnvProperties.CUSTOMERDISPLAY == "NO")
        return;
    if (me.show33now) return;
    // e-Beleg: jede neue Anzeige (naechster Kunde) loest den QR-Code ab.
    if (me.belegQRAktiv) {
        me.belegQRAktiv = false;
        clearTimeout(me.belegQRTimer);
    }

        me.sendToDisplay(me.createOutputHTML());
	me.reset();
/*	if (!POS.displayAdvertTo){
        	POS.displayAdvertTo = null;  //timer
	        POS.displayAdvertTo = setTimeout(function(){me.showAdvertising(me)}, 15000);
	}*/
}


function CDisplayLine() {
    this.elements = new Array();
    this.elementCount = 0;
}


CDisplay.prototype.addElement = function(text, anchor, align, start, end) {
    var Line = this.lines[this.lineCount - 1];
    Line.addElement(text, anchor, align, start, end);
}
CDisplayLine.prototype.addElement = function(text, anchor, align, start, end) {
    this.elements[this.elementCount] = new CDisplayLineElement(text, anchor, align, start, end);
    this.elementCount++;
}




CDisplay.prototype.createOutputHTML = function(){

	var html = null;
                    if (POS.isDisplayActive == 0) {
                        POS.isDisplayActive = 1;
                        fs.writeFile(POS.DisplayStatusFile, "1");
                    }
                    var content = "";
                    var text = "";
//                    var lines = null;
		    var me = this;
                    var displaylines = new Array(2);
                    displaylines[0] = "";
                    displaylines[1] = "";
                    var displaytask = null;
                    if (execto) {
                        clearTimeout(execto);
                        execto=null;
                    }
                    execto = setTimeout(function() {
                        POS.isDisplayActive = 0;
			me.showAdvertising(me);
                        fs.writeFile(POS.DisplayStatusFile, "0");
                    }, 20000);


                    var el = $("div[name='CFrame:" + POS.sessions.currentSession + ":8']");
                    var tab = el.find('table');

                    var showShopList = (tab.length > 0 && tab[0].childNodes[0].childElementCount > 0);

                    if (showShopList && me.lines && me.lines[0] && me.lines[0].elements && (me.lines[0].elements[0].text
                       == 'Retour:' || me.lines[0].elements[0].text == 'Bezahlt' || me.lines[0].elements[0].text == 'Zahlung:'
                       || me.lines[1].elements[0].text == 'Offen:' || me.lines[0].elements[0].text == 'Gegeben:')){
                        showShopList = false;

                    }

                    if (showShopList) { //zeigt Produkte mit Preis und Sunme

                        var newdisp = el.clone();
                        newdisp.css('top', "2vh");
                        newdisp.css('left', "2vw");
                        //newdisp.css('bottom', "10px");
                        newdisp.css('padding', "1vh");
                        newdisp.css('width', "94vw");
                        newdisp.css('height', "90vh");
                        newdisp.css('border', "3px solid black");
                        newdisp.css('display', "flex");
                        newdisp.css('flex-direction', "column");

                        var pres = newdisp.find('pre').css('font-size', '2.5vw');

                        var sumpre = newdisp.find("pre[name='CPre:" + POS.sessions.currentSession + ":8:1']");
                        sumpre.css('position', 'relative');
                        sumpre.css('bottom', '4vh');
                        sumpre.css('margin', '4vh');
                        sumpre.css('font-size', '10.5vw');
                        sumpre.css('color', '#00c000');
                        sumpre.css('order', '1');
                        var text = sumpre[0].innerText;
                        var sumindex = text.lastIndexOf("Summe");
                        var eurindex = text.indexOf("€", sumindex);
                        text = text.substring(sumindex, eurindex + 1);
                        var texts = text.split(' ');
                        var price = "   " + texts[texts.length - 2] + "€";
                        price = price.substr(-8);
                        sumpre[0].innerText = texts[0] + price;
                        //var sp = $("<span>");
                        //sp.css('right', '2vw');
                        //sp[0].innerText = texts[texts.length - 2] + "€";
                        //sumpre.append(sp);
                        //sumpre.val(text);
                        sumpre.remove();

                        var tablediv = $('<div>');
                        tablediv.css('overflow', "hidden");
                        tab = newdisp.find('table');
                        tab.find('tr').css('background-color', 'rgb(217,226,240)');
                        var tabneu = tab.clone();
                        if (tab) {
                            tab.remove();
                            var tr = tabneu.find('tr');
                            tr.parent().append(tr.get().reverse());
                            tablediv.append(tabneu);
                        }
                        newdisp.empty();
                        newdisp.append(tablediv);
                        newdisp.append(sumpre);
                        tablediv.before(sumpre);

                        var html1 = newdisp[0].outerHTML;
			html = '<head><meta charset="utf-8"/><title>Display</title><style>pre {font-size: 30px;font-weight:bold} body {overflow-y: hidden;overflow-x: hidden;} </style></head><body>'+
                        html1 + '</body>';
                    } else { //alle anderen Infos (bezahlt, gegeben, begruessung ...)
                        try {
                            var iterator = function it(cline) {

                                if (cline < 2 && me.lines) {
                                    //var currentLine = lines[cline];
                                    var currentLine = me.lines[cline];
                                    var displayElements = new Array();
                                    var lineLength = 20;

                                    //Iterate through all elements
                                    for (var celement = 0; celement < currentLine.elementCount; celement++) {
                                        var currentElement = currentLine.elements[celement];
                                        var start,
                                            end;
                                        text = String(currentElement.text);
                                        if (text.length == 0)
                                            continue;

                                        //sdump ("tx", text);

                                        if (currentElement.align == 0) {
                                            start = currentElement.anchor;
                                            end = start + text.length - 1;
                                        } else if (currentElement.align == 1) {
                                            end = currentElement.anchor;
                                            start = end - text.length + 1;
                                        } else {
                                            start = currentElement.anchor - Math.floor((text.length - 1) / 2);
                                            end = start + text.length - 1;
                                        }

                                        //sdump ("ste", start, end);

                                        var startshift = 0;
                                        var endshift = 0;

                                        if (start < currentElement.start) {
                                            startshift = currentElement.start - start;
                                        }
                                        if (end > currentElement.end) {
                                            endshift = end - currentElement.end;
                                        }

                                        // Correct startshift
                                        if (startshift > 0) {
                                            text = text.substring(startshift, text.length - startshift);
                                            start += startshift;
                                        }

                                        // Correct endshift
                                        if (endshift > 0) {
                                            text = text.substring(0, text.length - endshift);
                                            end -= endshift;
                                        }

                                        //sdump ("sts", startshift, endshift);
                                        //sdump ("tx2", text);

                                        var element = new Array();
                                        element["start"] = start;
                                        element["end"] = end;
                                        element["text"] = text;
                                        displayElements.push(element);
                                    }

                                    // send displayElements to printer
                                    var currentPos = 0;
                                    var streamText = ""; //new Buffer([]);


                                    var lastend = 0;
                                    var currentPOSPre = 0;
                                    for (var elms in displayElements) {
                                        //sdump ("stre", currentPos, displayElements[elms].start);

                                        for (; currentPos < displayElements[elms].start; currentPos++) {
                                            //streamText += " ";
                                            streamText = streamText + " ";
                                            currentPOSPre++;
                                        }

                                        text = displayElements[elms].text;
                                        streamText = streamText + text;

                                        currentPOSPre += text.length;
                                        currentPos = displayElements[elms].end + 1;

                                        lastend = displayElements[elms].end + 1;
                                    }
                                    for (; currentPOSPre < lineLength; currentPOSPre++) {
                                        streamText += " ";
                                        //streamText = Buffer.concat([streamText, new Buffer(" ")]);
                                    }


                                    //streamText = streamText.replace(/\I/g,'\|');
                                    streamText = streamText.replace(/\xD5/g, '&euro;');
                                    streamText = streamText.replace(/\x81/g, '&uuml;');
                                    streamText = streamText.replace(/\x9A/g, '&Uuml;');
                                    streamText = streamText.replace(/\x84/g, '&auml;');
                                    streamText = streamText.replace(/\x8E/g, '&Auml;');
                                    streamText = streamText.replace(/\x94/g, '&ouml;');
                                    streamText = streamText.replace(/\xE1/g, '&szlig;'); //0xE1
                                    displaylines[cline] = streamText;
                                    iterator(cline + 1);


                                } else {
                                    /*var contentType = 'text/html';
                                    res.writeHead(200, {
                                        'Content-Type': contentType
                                    });*/

                                    me.letzteInfo = [displaylines[0], displaylines[1]]; // fuer zeigeBelegQR
                                    html = '<head><meta charset="utf-8"/><title>Display</title><style>body {overflow-y: hidden;overflow-x: hidden;}  pre {font-size: 11vh;font-weight:bold} '+
                                    '#displaytext {border: 3px solid black;width: 92vw;padding: 3px 6vh;vertical-algin:middle;text-align: center}'+
                                    '</style></head><body><div id="displaytext" class="displaytext"><pre>' + displaylines[0] + '<br/>'+displaylines[1] + '</pre></div></body>';
                                }

                                //me.outputStream.close();
                            }
                            iterator(0);

                        } catch (e) {
                            log.add(1, "Error", "in Display Monitor: ", e); // + " - " + me.timerEvents[i].fnc.toSource());
                            var stack = e.stack.replace(/^[^\(]+?[\n$]/gm, '')
                                .replace(/^\s+at\s+/gm, '')
                                .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@')
                                .split('\n');

                            log.add(1, "Error", "Caught", "Stack: " + stack);
                            // hier stand ein Aufruf auf "res" - ein res gibt es hier nicht (Rest des
                            // alten Node-HTTP-Servers); es machte aus jedem gefangenen
                            // Fehler einen ungefangenen (Code-Suche 30.9.2026).
                        }
                    }
		return html;

}


// e-Beleg (§ 132a BAO, tools/E-BELEG.md): nach dem Bezahlen den Link zum
// digitalen Beleg als QR-Code zeigen - neben den letzten Infozeilen
// (z.B. "Retour"). Steht, bis die naechste Anzeige kommt (naechster Kunde),
// hoechstens BELEG_QR_MS (1 min); Werbung ist solange unterdrueckt.
var BELEG_QR_MS = 60000; // Nutzer 28.9.2026: 1 Minute, danach wieder Werbung
CDisplay.prototype.zeigeBelegQR = function(url, bild) {
    var me = this;
    if (POS.EnvProperties.CUSTOMERDISPLAY == "NO")
        return;
    if (execto) {
        clearTimeout(execto);
        execto = null;
    }
    clearTimeout(POS.displayAdvertTo);
    POS.displayAdvertTo = null;
    clearTimeout(me.belegQRTimer);
    me.belegQRAktiv = true;
    // Die Infozeilen sind auf 20 Zeichen mit Leerzeichen aufgefuellt - fuer
    // das Nebeneinander mit dem QR-Code hinten abschneiden.
    var info = (me.letzteInfo || ["", ""]).map(function(z) { return String(z).replace(/\s+$/, ""); });
    var html = '<head><meta charset="utf-8"/><title>Display</title><style>body{overflow:hidden;margin:0}' +
        '#belegqr{display:flex;align-items:center;justify-content:space-around;gap:3vw;height:96vh;border:3px solid black;box-sizing:border-box;padding:0 3vw}' +
        'pre{font-size:7vh;font-weight:bold;margin:0}' +
        '#belegqr>div{flex:none;width:54vh}' +
        '#belegqr img{width:54vh;height:54vh;image-rendering:pixelated;display:block}' +
        '#belegqr p{font:bold 3.6vh sans-serif;text-align:center;margin:2vh 0 0}</style></head>' +
        '<body><div id="belegqr"><pre>' + info[0] + '<br/>' + info[1] + '</pre>' +
        '<div><img alt="Link zum digitalen Beleg" data-beleg-url="' + String(url).replace(/"/g, "&quot;") + '" src="' + bild + '">' +
        '<p>Ihr Beleg digital:<br/>QR-Code mit dem Handy scannen</p></div></div></body>';
    me.sendToDisplay(html, me);
    me.belegQRTimer = setTimeout(function() {
        me.belegQRAktiv = false;
        POS.isDisplayActive = 0;
        fs.writeFile(POS.DisplayStatusFile, "0");
        me.showAdvertising(me);
    }, BELEG_QR_MS);
}

function CDisplayLineElement(text, anchor, align, start, end) {
    text = String(text);
    this.serialport = null;
    //sdump(" TX ", text);,
    text = text.replace(/\|/g, '\I');
    text = text.replace(/&euro;/g, '\xD5');
    //text = text.replace(/&euro;/g, 'e');
    text = text.replace(/&uuml;/g, '\x81');
    text = text.replace(/&Uuml;/g, '\x9A');
    text = text.replace(/&auml;/g, '\x84');
    text = text.replace(/&Auml;/g, '\x8E');
    text = text.replace(/&ouml;/g, '\x94');
    text = text.replace(/&szlig;/g, '\xE1'); //0xE1
    this.text = text;
    this.anchor = anchor;
    this.align = align;
    if (start < 0)
        start = 0;
    if (start > 19)
        start = 19;
    if (end < 0)
        end = 0;
    if (end > 19)
        end = 19;
    if (end < start)
        end = start;
    this.start = start;
    this.end = end;
}

export { CDisplay };
